{
  "title": "Reportes",
  "subtitle": "Análisis del trabajo de {team}.",
  "filters": {
    "all_projects": "Todos los proyectos",
    "all_departments": "Todos los equipos",
    "no_departments": "Sin equipos creados",
    "apply_range": "Aplicar rango",
    "from": "Desde",
    "to": "Hasta",
    "refresh": "Actualizar",
    "export_pdf": "Exportar PDF",
    "exporting": "Generando…",
    "n_teams": "{n} equipos",
    "one_team": "1 equipo",
    "no_teams": "Sin equipos",
    "teams_hint": "Selecciona uno o varios equipos para consolidar el informe.",
    "no_departments_hint": "Crea equipos en tu workspace para poder filtrar el informe por equipo."
  },
  "periods": {
    "default": "Últimos 7 días (por defecto)",
    "default_short": "Últimos 7 días",
    "last_30": "Últimos 30 días",
    "this_month": "Este mes",
    "last_month": "Mes anterior",
    "this_quarter": "Este trimestre",
    "this_year": "Este año",
    "custom": "Personalizado…",
    "range": "{from} – {to}"
  },
  "loading": "Cargando reportes…",
  "error_load": "No se pudieron cargar los reportes.",
  "error_pdf": "No se pudo generar el PDF.",
  "ai": {
    "button": "Resumen IA",
    "generating": "Generando resumen…",
    "title": "Resumen ejecutivo (IA)",
    "error": "No se pudo generar el resumen."
  },
  "send": {
    "button": "Enviar por correo",
    "title": "Enviar reporte por correo",
    "subtitle": "Se enviará el PDF del reporte con los filtros actuales.",
    "field_email": "Para",
    "field_cc": "CC (opcional)",
    "cc_placeholder": "correo1@empresa.com, correo2@empresa.com",
    "field_subject": "Asunto (opcional)",
    "subject_placeholder": "Reporte del equipo",
    "field_message": "Mensaje (opcional)",
    "message_placeholder": "Escribe una nota para el destinatario…",
    "cancel": "Cancelar",
    "submit": "Enviar",
    "sending": "Enviando…",
    "success": "Reporte enviado.",
    "error_email_required": "Indica el correo del destinatario.",
    "error_generic": "No se pudo enviar el reporte."
  },
  "kpis": {
    "open": "Abiertas",
    "open_detail": "En curso",
    "completed": "Completadas",
    "default_period": "Últimos 7 días",
    "overdue": "Atrasadas",
    "overdue_detail": "Pasaron la fecha",
    "unassigned": "Sin asignar",
    "unassigned_detail": "Riesgo de olvido",
    "not_applicable": "No aplica con filtro de equipo"
  },
  "workload": {
    "title": "Carga por persona",
    "subtitle": "Tareas abiertas",
    "empty": "Nadie tiene tareas abiertas asignadas."
  },
  "priority": {
    "title": "Prioridad del pipeline",
    "count_open": "{n} abiertas",
    "empty": "No hay tareas abiertas que priorizar.",
    "urgent": "Urgente",
    "high": "Alta",
    "medium": "Media",
    "low": "Baja"
  },
  "velocity": {
    "title": "Velocidad semanal",
    "created": "Creadas",
    "completed": "Completadas",
    "title_created": "{n} creadas",
    "title_completed": "{n} completadas"
  },
  "by_project": {
    "title": "Estado por proyecto",
    "empty": "Sin proyectos aún.",
    "done": "Hechas",
    "pending": "Pendientes"
  },
  "due": {
    "title": "Vencimientos",
    "subtitle": "De tareas abiertas",
    "overdue": "Vencidas",
    "today": "Hoy",
    "this_week": "Esta semana",
    "upcoming": "Próximas",
    "no_date": "Sin fecha"
  },
  "top_collaborators": {
    "title": "Top colaboradores",
    "subtitle": "Últimos 30 días",
    "empty": "Aún no hay actividad del mes.",
    "task_one": "tarea completada",
    "task_other": "tareas completadas",
    "comment_one": "comentario",
    "comment_other": "comentarios",
    "score": "{n} pts"
  }
}
